import React, { Component } from 'react';

import '../../../../../chat.css';
import {
    Magnifier,
    GlassMagnifier,
    SideBySideMagnifier,
    PictureInPictureMagnifier,
    MOUSE_ACTIVATION,
    TOUCH_ACTIVATION
} from "react-image-magnifiers";
/**
 * A message type that shows an image.
 */
class ImageMessage extends Component {
    render() {
        return(
            <div className={'image-message-container content-overlay-container'}>
                <SideBySideMagnifier
                    className={'image-message-image'}
                    imageSrc={this.props.url}
                    imageAlt={this.props.url}
                    largeImageSrc={this.props.url} // Optional
                    mouseActivation={MOUSE_ACTIVATION.DOUBLE_CLICK} // Optional
                    touchActivation={TOUCH_ACTIVATION.DOUBLE_TAP} // Optional
                    alwaysInPlace={true}
                />
            </div>
        );
    }
}

export default ImageMessage;
